export enum SearchContentEnum {
  TOP_RESULT = 'TOP_RESULT',
  CUSTOMER = 'CUSTOMER',
  PLANT = 'PLANT',
  PROJECT = 'PROJECT',
  PROJECT_PLUS_LIVE = 'PROJECT_PLUS_LIVE',
}
